export const monacoInitOptions = {
  foldingStrategy: 'indentation',
  fontSize: 14,
  automaticLayout: true,
  minimap: {
    enabled: false
  },
  lineNumbers: 'on',
  // fixedOverflowWidgets: true, // 不能使用这个选项，智能提示会失效
  theme: 'vs-dark',
  tabSize: 2,
  scrollbar: {
    horizontal: 'visible',
    vertical: 'visible'
  },
  wordWrap: 'on'
};
export const lsKey = 'editor_config';
export var EDITOR_TAB;
(function (EDITOR_TAB) {
  EDITOR_TAB["doc"] = "doc";
  EDITOR_TAB["debug"] = "debug";
})(EDITOR_TAB || (EDITOR_TAB = {}));
//# sourceMappingURL=consts.js.map
